module.exports = __webpack_public_path__ + "img/bulk.a677ff3d.png";